import React, { useState } from "react";
import { Card, Form, Input, Button, Typography, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const { Title, Text } = Typography;

export default function LoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const onFinish = async (v) => {
    setLoading(true);
    try {
      const u = await signIn(v.username.trim(), v.password);
      message.success(`خوش آمدید، ${u.full_name}`);
      // v2.169.0 — ورود از صفحهٔ اول/داشبورد ⇒ صفحهٔ اولِ همین کاربر (مثلاً پیگیری رنگرزی)؛ لینکِ مستقیمِ دیگر سرِ جایش می‌ماند
      if (["/", "/dashboard", "/login"].includes(location.pathname)) navigate("/", { replace: true });
    } catch (e) {
      message.error(e?.response?.data?.detail || "ورود ناموفق بود");
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      direction: "rtl", background: "var(--bg, #f0f2f5)", padding: 16,
    }}>
      <Card style={{ width: 380, maxWidth: "100%", boxShadow: "0 8px 30px rgba(0,0,0,0.12)" }}>
        <div style={{ textAlign: "center", marginBottom: 18 }}>
          <div style={{
            width: 52, height: 52, borderRadius: 14, background: "#1F4E79", color: "#fff",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            fontSize: 26, fontWeight: 700, marginBottom: 8,
          }}>ق</div>
          <Title level={4} style={{ margin: 0 }}>قرچک فکتوری</Title>
          <Text type="secondary">ورود به سیستم — زنجیره تأمین</Text>
        </div>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="username" label="نام کاربری" rules={[{ required: true, message: "نام کاربری را وارد کنید" }]}>
            {/* name/id/autoComplete تا اپِ پسوردِ گوشی و مرورگر autofill را پیشنهاد دهند */}
            <Input prefix={<UserOutlined />} placeholder="نام کاربری" autoFocus size="large"
              name="username" id="username" autoComplete="username" />
          </Form.Item>
          <Form.Item name="password" label="رمز عبور" rules={[{ required: true, message: "رمز عبور را وارد کنید" }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="رمز عبور" size="large"
              name="password" id="password" autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block size="large"
            style={{ background: "#1F4E79" }}>
            ورود
          </Button>
        </Form>
      </Card>
    </div>
  );
}
